import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export type NameEditData = { firstName: string; lastName: string };
export type NameEditResult = { firstName: string; lastName: string } | undefined;

@Component({
  selector: 'app-name-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './name-edit-dialog.component.html',
  styleUrls: ['./name-edit-dialog.component.scss']
})
export class NameEditDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NameEditDialogComponent, NameEditResult>,
    @Inject(MAT_DIALOG_DATA) public data: NameEditData
  ) {
    this.form = this.fb.group({
      firstName: [data.firstName ?? '', [Validators.required, Validators.maxLength(100)]],
      lastName:  [data.lastName  ?? '', [Validators.required, Validators.maxLength(100)]],
    });
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onSave(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value as { firstName: string; lastName: string });
    }
  }
}
